import { render } from "./OrderTracking.vue?vue&type=template&id=37ca6f67&scoped=true"
import script from "./OrderTracking.vue?vue&type=script&lang=js"
export * from "./OrderTracking.vue?vue&type=script&lang=js"

import "./OrderTracking.vue?vue&type=style&index=0&id=37ca6f67&scoped=true&lang=css"

import exportComponent from "/Users/andresrivas/NoSincronizar/Vue/Swift Fulfillment/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ca6f67"]])

export default __exports__